import React from 'react';
import { Box } from '@mui/material';
import { Dialog } from '../../../../Components/MUIs';
import { EXCEL_SHEET_MODE } from './SER_BASIC_01_Excel';
import './SerEvalExcelDownloadDialog.styles.css';

const SHEET_OPTIONS = [
  {
    value: EXCEL_SHEET_MODE.SPLIT,
    icon: 'view_week',
    title: '대분류별 시트 분리',
    desc: '대분류마다 별도 시트로 구분해 다운로드합니다. 항목별 상세 확인에 적합합니다.',
  },
  {
    value: EXCEL_SHEET_MODE.SINGLE,
    icon: 'table_rows',
    title: '단일 시트 통합',
    desc: '모든 대분류를 한 시트에 이어서 표시합니다. 전체 내용을 한눈에 볼 때 적합합니다.',
  },
];

/** 중대재해 평가 엑셀 다운로드 — 시트 구성 선택 다이얼로그 */
function SerEvalExcelDownloadDialog({
  open = false,
  sheetMode = EXCEL_SHEET_MODE.SPLIT,
  onSheetModeChange,
  onClose,
  onConfirm,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="엑셀 다운로드"
      maxWidth="sm"
      fullWidth
      useSaveButton
      useSaveAfterClose={false}
      saveButtonName="다운로드"
      onSave={onConfirm}
      closeButtonName="취소"
      titleSx={{ pb: 2, fontWeight: 700 }}
      contentSx={{ pt: 3, px: 2.5, pb: 2.5 }}
      content={
        <Box
          className="ser-excel-dialog"
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <div className="ser-excel-dialog__intro">
            <div className="ser-excel-dialog__intro-icon">
              <span className="material-symbols-outlined">download</span>
            </div>
            <div>
              <div className="ser-excel-dialog__intro-title">
                다운로드할 엑셀 시트 구성을 선택해 주세요
              </div>
              <p className="ser-excel-dialog__intro-desc">
                평가 데이터를 대분류별로 나누거나, 한 시트에 모아서 받을 수
                있습니다.
              </p>
            </div>
          </div>

          <div>
            <div className="ser-excel-dialog__section-label">시트 구성</div>
            <div className="ser-excel-dialog__options" role="radiogroup">
              {SHEET_OPTIONS.map((option) => {
                const isSelected = sheetMode === option.value;
                return (
                  <button
                    key={option.value}
                    type="button"
                    role="radio"
                    aria-checked={isSelected}
                    className={`ser-excel-dialog__option ${isSelected ? 'is-selected' : ''}`}
                    onClick={() => onSheetModeChange?.(option.value)}
                  >
                    <div className="ser-excel-dialog__option-top">
                      <div className="ser-excel-dialog__option-icon">
                        <span className="material-symbols-outlined">
                          {option.icon}
                        </span>
                      </div>
                      <div className="ser-excel-dialog__option-body">
                        <div className="ser-excel-dialog__option-head">
                          <div className="ser-excel-dialog__option-title">
                            {option.title}
                          </div>
                          {option.badge ? (
                            <span className="ser-excel-dialog__option-badge">
                              {option.badge}
                            </span>
                          ) : null}
                        </div>
                        <p className="ser-excel-dialog__option-desc">
                          {option.desc}
                        </p>
                      </div>
                      <div className="ser-excel-dialog__option-check">
                        {isSelected ? (
                          <span className="material-symbols-outlined">check</span>
                        ) : null}
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </Box>
      }
    />
  );
}

export default SerEvalExcelDownloadDialog;
